import { render, staticRenderFns } from "./feedbackDialog.vue?vue&type=template&id=52789508&scoped=true"
import script from "./feedbackDialog.vue?vue&type=script&lang=js"
export * from "./feedbackDialog.vue?vue&type=script&lang=js"
import style0 from "./feedbackDialog.vue?vue&type=style&index=0&id=52789508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52789508",
  null
  
)

export default component.exports